import { gql } from '@/__generated__';

export const GET_OPERATIONAL_STATE = gql(`#graphql
  query GetOperationalState($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        id
        name
        operationalState
      }
    }
  }
`);
